var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view app-main-page-tab" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "app-main-inner-row" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  "label-width": "80px",
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_BusinessType") + ":"
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "select-type":
                          _vm.selectTypeNames.local_cache_SystemConstants$LOBS,
                        "show-custom-label-in-option": true,
                        "default-value": _vm.searchConditions.lob
                      },
                      on: { parentCallBack: _vm.lobChangeHandler }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SystemMaintenance.BusinessMode") + ":"
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        disabled: !_vm.searchConditions.lob,
                        filterable: "",
                        "callback-method-type": "value",
                        "static-options": _vm.operateTypeList,
                        "default-value": _vm.searchConditions.operateType,
                        "tag-name": "chineseName",
                        "tag-value": "code"
                      },
                      on: { parentCallBack: _vm.onOperateTypeChange }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "110px",
                      label: _vm.$t("CargoMsg.Cargo_CustomJobType") + ":"
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        disabled: !_vm.searchConditions.lob,
                        "select-type":
                          _vm.selectTypeNames.basic_data_CutomJobType,
                        filterable: "",
                        "method-params": {
                          type: _vm.searchConditions.lob,
                          active: true
                        },
                        "default-value": _vm.searchConditions.customJobType
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.searchConditions.customJobType = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_AirlineCode") + ":" }
                  },
                  [
                    _vm.isSea || _vm.isAir || _vm.isIe
                      ? _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Region,
                            filterable: "",
                            "default-value": _vm.searchConditions.region,
                            "tag-name": "code"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.searchConditions.region = p.value
                            }
                          }
                        })
                      : _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.selectTypeNames.basic_data_RailwayLine,
                            filterable: "",
                            "default-value": _vm.searchConditions.region,
                            "tag-name": "code"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.searchConditions.region = p.value
                            }
                          }
                        })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label:
                        _vm.$t("SystemMaintenance.AirlineChineseName") + ":"
                    }
                  },
                  [
                    _vm.isSea || _vm.isAir || _vm.isIe
                      ? _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Region,
                            filterable: "",
                            "default-value": _vm.region2,
                            "tag-name": "name"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.region2 = p.value
                            }
                          }
                        })
                      : _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.selectTypeNames.basic_data_RailwayLine,
                            filterable: "",
                            "default-value": _vm.region2,
                            "tag-name": "name"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.region2 = p.value
                            }
                          }
                        })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SystemMaintenance.DeparturePortCode") + ":"
                    }
                  },
                  [
                    _vm.isSea || _vm.isAir || _vm.isIe
                      ? _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.isSea || _vm.isIe
                                ? _vm.selectTypeNames.static_data_Seaport
                                : _vm.selectTypeNames.static_data_Airport,
                            "static-options":
                              _vm.isSea || _vm.isIe
                                ? _vm.allSeaport
                                : _vm.allAirport,
                            filterable: "",
                            "callback-params": { key: "loadingPort" },
                            "default-value": _vm.searchConditions.loadingPort,
                            "tag-name": "code"
                          },
                          on: { parentCallBack: _vm.setQueryData }
                        })
                      : _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.selectTypeNames.static_data_RailwayStation,
                            "static-options": _vm.allRailwayStation,
                            filterable: "",
                            "callback-params": { key: "loadingPort" },
                            "default-value": _vm.searchConditions.loadingPort,
                            "tag-name": "code"
                          },
                          on: { parentCallBack: _vm.setQueryData }
                        })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "90px",
                      label: _vm.$t("SystemMaintenance.OriginPortEnName") + ":"
                    }
                  },
                  [
                    _vm.isSea || _vm.isAir || _vm.isIe
                      ? _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.isSea || _vm.isIe
                                ? _vm.selectTypeNames.static_data_Seaport
                                : _vm.selectTypeNames.static_data_Airport,
                            "static-options":
                              _vm.isSea || _vm.isIe
                                ? _vm.allSeaport
                                : _vm.allAirport,
                            filterable: "",
                            "default-value": _vm.port2,
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.port2 = p.value
                            }
                          }
                        })
                      : _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.selectTypeNames.static_data_RailwayStation,
                            "static-options": _vm.allRailwayStation,
                            filterable: "",
                            "default-value": _vm.port2,
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.port2 = p.value
                            }
                          }
                        })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.PortCodeOfDischarge") + ":"
                    }
                  },
                  [
                    _vm.isSea || _vm.isAir || _vm.isIe
                      ? _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.isSea || _vm.isIe
                                ? _vm.selectTypeNames.static_data_Seaport
                                : _vm.selectTypeNames.static_data_Airport,
                            "static-options":
                              _vm.isSea || _vm.isIe
                                ? _vm.allSeaport
                                : _vm.allAirport,
                            filterable: "",
                            "callback-params": { key: "port" },
                            "default-value": _vm.searchConditions.port,
                            "tag-name": "code"
                          },
                          on: { parentCallBack: _vm.setQueryData }
                        })
                      : _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.selectTypeNames.static_data_RailwayStation,
                            "static-options": _vm.allRailwayStation,
                            filterable: "",
                            "callback-params": { key: "port" },
                            "default-value": _vm.searchConditions.port,
                            "tag-name": "code"
                          },
                          on: { parentCallBack: _vm.setQueryData }
                        })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "90px",
                      label:
                        _vm.$t("SystemMaintenance.UnloadingEortEnName") + ":"
                    }
                  },
                  [
                    _vm.isSea || _vm.isAir || _vm.isIe
                      ? _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.isSea || _vm.isIe
                                ? _vm.selectTypeNames.static_data_Seaport
                                : _vm.selectTypeNames.static_data_Airport,
                            "static-options":
                              _vm.isSea || _vm.isIe
                                ? _vm.allSeaport
                                : _vm.allAirport,
                            filterable: "",
                            "default-value": _vm.port2,
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.port2 = p.value
                            }
                          }
                        })
                      : _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            disabled: !_vm.searchConditions.lob,
                            "select-type":
                              _vm.selectTypeNames.static_data_RailwayStation,
                            "static-options": _vm.allRailwayStation,
                            filterable: "",
                            "default-value": _vm.port2,
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.port2 = p.value
                            }
                          }
                        })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.WarehouseSupplier") + ":"
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        filterable: "",
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        "method-params": { warehouse: true, active: true },
                        "default-value": _vm.searchConditions.warehouseId || ""
                      },
                      on: { parentCallBack: _vm.onWarehouseIdChange }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.WareHouseName") + ":" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: {
                          filterable: "",
                          clearable: true,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        model: {
                          value: _vm.searchConditions.warehouseName,
                          callback: function($$v) {
                            _vm.$set(_vm.searchConditions, "warehouseName", $$v)
                          },
                          expression: "searchConditions.warehouseName"
                        }
                      },
                      _vm._l(_vm.warehouseNameList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { value: item.warehouseName }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.CustomsBroker") + ":" } },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        filterable: "",
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        "method-params": { customsBroker: true, active: true },
                        "default-value":
                          _vm.searchConditions.customsBroker || ""
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.searchConditions.customsBroker = p.value || 0
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SeaExport.DestinationAgent") + ":" }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        filterable: "",
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        "method-params": { overseaAgent: true, active: true },
                        "default-value":
                          _vm.searchConditions.destinationAgent || "",
                        "tag-name": "englishName"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.searchConditions.destinationAgent = p.value || 0
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "100px",
                      label: _vm.$t("SeaExport.opOffice") + ":"
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "select-type":
                          _vm.selectTypeNames.basic_data_Office_All,
                        filterable: "",
                        "static-options": _vm.officeList,
                        "default-value": _vm.searchConditions.opOffice,
                        "tag-name": "code"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.searchConditions.opOffice = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "100px",
                      label: _vm.$t("CargoMsg.Cargo_Carrier") + ":"
                    }
                  },
                  [
                    _vm.searchConditions.lob === "SE"
                      ? _c("cargo-company-select", {
                          attrs: {
                            "method-params": {
                              companyLob: "seaExport",
                              seaCmp: true,
                              active: true
                            },
                            "default-value": _vm.searchConditions.carrierId,
                            "custom-style": "width: 200px"
                          },
                          on: {
                            change: function(p) {
                              _vm.searchConditions.carrierId = p.value
                            }
                          }
                        })
                      : _vm.routeWareHouseForm.lob === "SI"
                      ? _c("cargo-company-select", {
                          attrs: {
                            "method-params": {
                              companyLob: "seaImport",
                              seaCmp: true,
                              active: true
                            },
                            "default-value": _vm.searchConditions.carrierId,
                            "custom-style": "width: 200px"
                          },
                          on: {
                            change: function(p) {
                              _vm.searchConditions.carrierId = p.value
                            }
                          }
                        })
                      : _vm.routeWareHouseForm.lob === "AE"
                      ? _c("cargo-company-select", {
                          attrs: {
                            "method-params": {
                              companyLob: "airExport",
                              airCmp: true,
                              active: true
                            },
                            "default-value": _vm.searchConditions.carrierId,
                            "custom-style": "width: 200px"
                          },
                          on: {
                            change: function(p) {
                              _vm.searchConditions.carrierId = p.value
                            }
                          }
                        })
                      : _vm.routeWareHouseForm.lob === "AI"
                      ? _c("cargo-company-select", {
                          attrs: {
                            "method-params": {
                              companyLob: "airImport",
                              airCmp: true,
                              active: true
                            },
                            "default-value": _vm.searchConditions.carrierId,
                            "custom-style": "width: 200px"
                          },
                          on: {
                            change: function(p) {
                              _vm.searchConditions.carrierId = p.value
                            }
                          }
                        })
                      : _vm.searchConditions.lob === "IE" &&
                        _vm.searchConditions.operateType === "IC"
                      ? _c("cargo-company-select", {
                          attrs: {
                            "method-params": {
                              companyLob: "integratedJob",
                              truckCmp: true,
                              active: true
                            },
                            "default-value": _vm.searchConditions.carrierId,
                            "custom-style": "width: 200px"
                          },
                          on: {
                            change: function(p) {
                              _vm.searchConditions.carrierId = p.value
                            }
                          }
                        })
                      : _c("el-select", {
                          staticStyle: { width: "200px" },
                          attrs: { disabled: "", value: "", placeholder: " " }
                        })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { value: _vm.config.value === "1" },
                        on: { input: _vm.onConfigInput }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SystemMaintenance.ConfigApplyRemoteBooking")
                          )
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.fetchRouteWareHouseMappingList(1)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.popRouteWareHouseAddDialog }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.popRouteWareHouseEditFormDialog }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.toDelete }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "260302",
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.searchConditions.total > 0,
                  expression: "searchConditions.total>0"
                }
              ],
              attrs: {
                "config-module": "260302",
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.fetchRouteWareHouseMappingList
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.isShowRouteWareHouseMaintain,
            title: _vm.$t("CargoMsg.Cargo_RouteAndWarehouseConfiguration"),
            "inline-message": "",
            width: "1100px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowRouteWareHouseMaintain = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex-column" },
            [
              _c(
                "div",
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("SystemMaintenance.MatchingCriteriaSelection")
                      )
                    )
                  ]),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t(
                          "SystemMaintenance.MatchingCriteriaSelectionTip"
                        ),
                        placement: "right"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning",
                        staticStyle: {
                          color: "#E6A23C",
                          "font-size": "14px",
                          "margin-left": "5px"
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: { "label-width": "100px", inline: "" }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.opOffice")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_Office_All,
                          filterable: "",
                          multiple: true,
                          "static-options": _vm.officeList,
                          "default-multiple-value": _vm.toNumArray(
                            _vm.routeWareHouseForm.multipleOpOffice
                          ),
                          "tag-name": "code"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.routeWareHouseForm.multipleOpOffice = _vm.toTxt(
                              p.value
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.PleaseSelectARoute")
                            )
                          )
                        ]
                      ),
                      _vm.isSeaOfForm || _vm.isAirOfForm || _vm.isIeOfForm
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              "static-options":
                                _vm.isSeaOfForm || _vm.isIeOfForm
                                  ? _vm.seaRegionList
                                  : _vm.airRegionList,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.routeWareHouseForm.regionCode
                              ),
                              "tag-name": "name"
                            },
                            on: { parentCallBack: _vm.onMultipleRegionChange }
                          })
                        : _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_RailwayLine,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.routeWareHouseForm.regionCode
                              ),
                              "tag-name": "name"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.routeWareHouseForm.regionCode = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$LOBS,
                          "show-custom-label-in-option": true,
                          "default-value": _vm.routeWareHouseForm.lob,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.ddlLobChangeHandler(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessModel")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          filterable: "",
                          multiple: true,
                          "callback-method-type": "value",
                          "static-options": _vm.operateTypeListOfForm,
                          "default-multiple-value": _vm.isAirOfForm
                            ? _vm.toNumArray(
                                _vm.routeWareHouseForm.multipleOperateType
                              )
                            : _vm.toArray(
                                _vm.routeWareHouseForm.multipleOperateType
                              ),
                          "tag-name": "chineseName",
                          "tag-value": "code"
                        },
                        on: { parentCallBack: _vm.onFormOperateTypeChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.PleaseSelectDeparturePort"
                              )
                            )
                          )
                        ]
                      ),
                      _vm.isSeaOfForm || _vm.isIeOfForm
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "static-options": _vm.portList,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.routeWareHouseForm.multipleLoadingPortCode
                              ),
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.routeWareHouseForm.multipleLoadingPortCode = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.isAirOfForm
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "static-options": _vm.portList,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.routeWareHouseForm.multipleLoadingPortCode
                              ),
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.routeWareHouseForm.multipleLoadingPortCode = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_RailwayStation,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.routeWareHouseForm.multipleLoadingPortCode
                              ),
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.routeWareHouseForm.multipleLoadingPortCode = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.PleaseSelectUnloadingPort"
                              )
                            )
                          )
                        ]
                      ),
                      _vm.isSeaOfForm || _vm.isIeOfForm
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "static-options": _vm.portList,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.routeWareHouseForm.multiplePortCode
                              ),
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.routeWareHouseForm.multiplePortCode = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.isAirOfForm
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "static-options": _vm.portList,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.routeWareHouseForm.multiplePortCode
                              ),
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.routeWareHouseForm.multiplePortCode = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_RailwayStation,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.toArray(
                                _vm.routeWareHouseForm.multiplePortCode
                              ),
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.routeWareHouseForm.multiplePortCode = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CustomJobType")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          multiple: true,
                          "method-params": {
                            type: _vm.routeWareHouseForm.lob,
                            active: true
                          },
                          "default-multiple-value": _vm.toArray(
                            _vm.routeWareHouseForm.multipleCustomJobType
                          )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.routeWareHouseForm.multipleCustomJobType = _vm.toTxt(
                              p.value
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.PleaseSelectCarrier")
                            )
                          )
                        ]
                      ),
                      _vm.routeWareHouseForm.lob === "SE"
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "seaExport",
                                seaCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.routeWareHouseForm.multipleCarrierId
                              ),
                              "custom-style": "width: 250px"
                            },
                            on: {
                              change: function(p) {
                                _vm.routeWareHouseForm.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.routeWareHouseForm.lob === "SI"
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "seaImport",
                                seaCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.routeWareHouseForm.multipleCarrierId
                              ),
                              "custom-style": "width: 250px"
                            },
                            on: {
                              change: function(p) {
                                _vm.routeWareHouseForm.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.routeWareHouseForm.lob === "AE"
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "airExport",
                                airCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.routeWareHouseForm.multipleCarrierId
                              ),
                              "custom-style": "width: 250px"
                            },
                            on: {
                              change: function(p) {
                                _vm.routeWareHouseForm.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.routeWareHouseForm.lob === "AI"
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "airImport",
                                airCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.routeWareHouseForm.multipleCarrierId
                              ),
                              "custom-style": "width: 250px"
                            },
                            on: {
                              change: function(p) {
                                _vm.routeWareHouseForm.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _vm.routeWareHouseForm.lob === "IE" &&
                          _vm.routeWareHouseForm.multipleOperateType.indexOf(
                            "IC"
                          ) > -1
                        ? _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                companyLob: "integratedJob",
                                truckCmp: true,
                                active: true
                              },
                              multiple: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.routeWareHouseForm.multipleCarrierId
                              ),
                              "custom-style": "width: 250px"
                            },
                            on: {
                              change: function(p) {
                                _vm.routeWareHouseForm.multipleCarrierId = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        : _c("el-select", {
                            staticStyle: { width: "250px" },
                            attrs: { disabled: "", value: "", placeholder: " " }
                          })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticStyle: {
                  width: "calc(100% + 20px)",
                  "margin-left": "-10px",
                  "margin-top": "10px",
                  "margin-bottom": "10px",
                  "border-top": "1px solid #E3E3E3"
                }
              }),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-top": "10px" } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "350px" } },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SystemMaintenance.PresetValueConfiguration")
                          )
                        )
                      ]),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t(
                              "SystemMaintenance.PresetValueConfigurationTip"
                            ),
                            placement: "right"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              color: "#E6A23C",
                              "font-size": "14px",
                              "margin-left": "5px"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticStyle: { "margin-left": "18px" } }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SystemMaintenance.SetLeadTimeBasedOnETDTime")
                        )
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: { "label-width": "100px", inline: "" }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.AssociatedWarehouseSupplier"
                              )
                            )
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { warehouse: true, active: true },
                          "default-value": _vm.routeWareHouseForm.warehouseId
                        },
                        on: { parentCallBack: _vm.onWarehouseIdFormChange }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.CargosExpectedArrivalDate"))
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticStyle: { width: "250px" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            disabled: !_vm.isSeAe,
                            precision: 0,
                            min: 0
                          },
                          model: {
                            value: _vm.routeWareHouseForm.arriveDateIncrement,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "arriveDateIncrement",
                                $$v
                              )
                            },
                            expression: "routeWareHouseForm.arriveDateIncrement"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Days")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerClosingTime")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { width: "250px" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            disabled: !_vm.isSeAe,
                            precision: 0,
                            min: 0
                          },
                          model: {
                            value:
                              _vm.routeWareHouseForm
                                .customerFileCutoffIncrement,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "customerFileCutoffIncrement",
                                $$v
                              )
                            },
                            expression:
                              "routeWareHouseForm.customerFileCutoffIncrement"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Days")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.AssociatedWarehouseName"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: {
                            filterable: "",
                            clearable: true,
                            placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                          },
                          model: {
                            value: _vm.routeWareHouseForm.warehouseName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "warehouseName",
                                $$v
                              )
                            },
                            expression: "routeWareHouseForm.warehouseName"
                          }
                        },
                        _vm._l(_vm.warehouseNameFormList, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.warehouseName }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("Pricing.ClosingTime")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { width: "250px" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            disabled: !_vm.isSeAe,
                            precision: 0,
                            min: 0
                          },
                          model: {
                            value: _vm.routeWareHouseForm.fileCutoffIncrement,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "fileCutoffIncrement",
                                $$v
                              )
                            },
                            expression: "routeWareHouseForm.fileCutoffIncrement"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Days")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerCyCutOffDate")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { width: "250px" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            disabled: !_vm.isSeAe,
                            precision: 0,
                            min: 0
                          },
                          model: {
                            value:
                              _vm.routeWareHouseForm.customerCutoffIncrement,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "customerCutoffIncrement",
                                $$v
                              )
                            },
                            expression:
                              "routeWareHouseForm.customerCutoffIncrement"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Days")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.RelatedCustomsBroker")
                            )
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "callback-params": {
                            key: "customsBroker",
                            active: true
                          },
                          "callback-method-type": "value",
                          "default-value": _vm.routeWareHouseForm.customsBroker
                        },
                        on: { parentCallBack: _vm.getValueFromChild }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SystemMaintenance.CustomsClosingTime"))
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticStyle: { width: "250px" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            disabled: !_vm.isSeAe,
                            precision: 0,
                            min: 0
                          },
                          model: {
                            value: _vm.routeWareHouseForm.customCutoffIncrement,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "customCutoffIncrement",
                                $$v
                              )
                            },
                            expression:
                              "routeWareHouseForm.customCutoffIncrement"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Days")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerShutOutDate")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { width: "250px" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            disabled: !_vm.isSeAe,
                            precision: 0,
                            min: 0
                          },
                          model: {
                            value:
                              _vm.routeWareHouseForm.customerShutoutIncrement,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "customerShutoutIncrement",
                                $$v
                              )
                            },
                            expression:
                              "routeWareHouseForm.customerShutoutIncrement"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Days")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.RelatedDestinationAgent"
                              )
                            )
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "callback-params": {
                            key: "destinationAgent",
                            active: true
                          },
                          "callback-method-type": "value",
                          "default-value":
                            _vm.routeWareHouseForm.destinationAgent
                        },
                        on: { parentCallBack: _vm.getValueFromChild }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value:
                              _vm.routeWareHouseForm
                                .dateCalculateIncludeCurrentDay,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "dateCalculateIncludeCurrentDay",
                                $$v
                              )
                            },
                            expression:
                              "routeWareHouseForm.dateCalculateIncludeCurrentDay"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.CalculateDateIncludeETDTheDay"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value:
                              _vm.routeWareHouseForm
                                .calculateIncludeEtdIsWeekend,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "calculateIncludeEtdIsWeekend",
                                $$v
                              )
                            },
                            expression:
                              "routeWareHouseForm.calculateIncludeEtdIsWeekend"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.CalculateIncludeEtdIsWeekend"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: { "label-width": "100px", inline: "" }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.DefaultConfigurationNotes"
                              )
                            )
                          )
                        ]
                      ),
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        attrs: { type: "textarea", rows: "3" },
                        model: {
                          value: _vm.routeWareHouseForm.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.routeWareHouseForm, "remark", $$v)
                          },
                          expression: "routeWareHouseForm.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SystemMaintenance.PortRequirementBillRequirements"
                            )
                          )
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex-column",
                        staticStyle: { width: "250px" }
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: "3" },
                          model: {
                            value: _vm.routeWareHouseForm.portRequirement,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routeWareHouseForm,
                                "portRequirement",
                                $$v
                              )
                            },
                            expression: "routeWareHouseForm.portRequirement"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "line-height": "18px",
                              "margin-top": "5px",
                              cursor: "pointer"
                            },
                            on: { click: _vm.openAttachment }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-upload2",
                              staticStyle: { "font-size": "18px" }
                            }),
                            _c(
                              "div",
                              { staticStyle: { "font-size": "14px" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.RelatedInstructionsAttachments"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitRouteWareHouseManagement }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c("el-button", { on: { click: _vm.cancelSaveOrEdit } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ]
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.routeWareHouseForm,
          lob: _vm.routeWareHouseForm.lob,
          "show-all": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }